module.exports = __webpack_public_path__ + "components/weather-icon/static/daymodsnow@3-fc78314d866bf0c4c81778b95c7b39b1.png";